const icons = {
  'image/jpeg': 'mdi-file-image-outline',
  'image/dds': 'mdi-file-image-outline',
  'image/png': 'mdi-file-image-outline',
  'video/mp4': 'mdi-file-video-outline',
  'video/mov': 'mdi-file-video-outline',
  'video/ts': 'mdi-file-video-outline',
  'video/mkv': 'mdi-file-video-outline',
  'video/avi': 'mdi-file-video-outline',
  'video/wmv': 'mdi-file-video-outline',
  'video/wma': 'mdi-file-video-outline',
  'video/asf': 'mdi-file-video-outline',
  'video/ogg': 'mdi-file-video-outline',
  'video/flv': 'mdi-file-video-outline',
  'video/mpeg': 'mdi-file-video-outline',
  'video/mpg': 'mdi-file-video-outline',
  'video/f4v': 'mdi-file-video-outline',
  'video/m2ts': 'mdi-file-video-outline',
  'video/vob': 'mdi-file-video-outline',
  'video/webm': 'mdi-file-video-outline',
  video_feed: 'mdi-video-input-hdmi',
  video_input: 'mdi-video-input-hdmi',
  live_stream: 'mdi-video-wireless',
  ndi: 'mdi-access-point-network',
  json: 'mdi-code-json',
  'application/json': 'mdi-code-json',
};

export function iconByType(type) {
  return icons[type] || 'mdi-file-outline';
}
